import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Changes you save will only apply to new documents. Existing documents will not be modified.',
    next: 'I understand',
    stopAlert: 'Don’t tell me again',
    title: 'Saved changes',
  },
  fr: {
    description:
      'Les modifications enregistrées s’appliquent uniquement à vos nouveaux documents. Les documents déjà existants ne sont pas modifiés.',
    next: 'J’ai compris',
    stopAlert: 'Ne plus m’alerter',
    title: 'Modifications enregistrées',
  },
} as const);

export default locales;
